import React, { useContext, useEffect, useState } from 'react';
import { DataLayerEventContext } from '../contexts/dataLayerEventContext';
import { ScreensContext } from '../contexts/screensContext';
import WelcomeComponent from '../components/sgm-personalcabinet/welcome-component';
import RulesComponent from '../components/sgm-personalcabinet/rules-component';
import FaqComponent from '../components/sgm-personalcabinet/faq-component';
import PointHistoryComponent from '../components/sgm-personalcabinet/point-history-component';
import QuestionComponent from '../components/sgm-personalcabinet/question-component';
import PointChangeComponent from '../components/sgm-personalcabinet/point-change-component';
import CertificateComponent from '../components/sgm-personalcabinet/certificate-component';
import QrCodeComponent from '../components/sgm-personalcabinet/qr-code-component';
import PhoneComponent from '../components/sgm-personalcabinet/phone-component';
import BarcodeComponent from '../components/sgm-personalcabinet/barcode-component';
import sgmService from '../services/sgmService';
import ErrorComponent from '../components/sgm-personalcabinet/error-component';
import ChangeErrorComponent from '../components/sgm-personalcabinet/change-error-component';
import TermsPopupComponent from '../components/sgm-personalcabinet/terms-popup-component';
import CookieManagementComponent from '../components/sgm-personalcabinet/cookie-management-component';

const TERMS_ACCEPTED_KEY = 'sgm_terms_accepted';
const EMP_ID_KEY = 'sgm_emp_id';

const SGMPersonalCabinet = () => {
  const [screenNumber, setScreenNumber] = useState(1);
  const [isQuestionOpen, setIsQuestionOpen] = useState(false);
  const [endSessionType, setEndSessionType] = useState('SESSION_END');
  const [isDisplayedAll, setIsDisplayedAll] = useState(false);
  const [selectedCertificate, setSelectedCertificate] = useState(null);
  const [pointChangeTab, setPointChangeTab] = useState('offers');
  const [isAuthLoading, setIsAuthLoading] = useState(true);
  const [isTermsAccepted, setIsTermsAccepted] = useState(
    () => localStorage.getItem(TERMS_ACCEPTED_KEY) === 'true'
  );
  const { init } = useContext(DataLayerEventContext);

  const handleAcceptTerms = () => {
    localStorage.setItem(TERMS_ACCEPTED_KEY, 'true');
    setIsTermsAccepted(true);
  };

  useEffect(() => {
    init('SGM-PersonalCabinet');
  }, [init]);

  useEffect(() => {
    (async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const assistantId =
          urlParams.get('assistant_id') || urlParams.get('telegram_id');
        const posCode = urlParams.get('utm_partner');
        const urlEmpId = urlParams.get('emp_id');

        if (urlEmpId) sessionStorage.setItem(EMP_ID_KEY, urlEmpId);

        const empId = urlEmpId || sessionStorage.getItem(EMP_ID_KEY);

        if (assistantId) {
          const data = await sgmService.sgmAuth(assistantId, posCode, empId);

          if (data?.accessToken) {
            localStorage.setItem('s_a_t', data.accessToken);
            return;
          }
        }

        setScreenNumber(100);
      } catch (error) {
        setScreenNumber(100);
      } finally {
        setIsAuthLoading(false);
      }
    })();
  }, []);

  const getScreen = (number, cb) => {
    switch (number) {
      case 1: {
        return (
          <WelcomeComponent
            setScreenNumber={setScreenNumber}
            onChangePointClick={() => {
              setPointChangeTab('offers');
              setScreenNumber(4);
            }}
            onCertificatesClick={() => {
              setPointChangeTab('certificates');
              setScreenNumber(4);
            }}
            onQuestionClick={() => setIsQuestionOpen(true)}
          />
        );
      }
      case 2: {
        return (
          <RulesComponent
            setScreenNumber={setScreenNumber}
            onQuestionClick={() => setIsQuestionOpen(true)}
          />
        );
      }
      case 3: {
        return (
          <PointHistoryComponent
            setScreenNumber={setScreenNumber}
            onQuestionClick={() => setIsQuestionOpen(true)}
          />
        );
      }
      case 4: {
        return (
          <PointChangeComponent
            initialTab={pointChangeTab}
            setScreenNumber={setScreenNumber}
            onQuestionClick={() => setIsQuestionOpen(true)}
            onCertificateClick={(certificate) => {
              setSelectedCertificate(certificate);
              setScreenNumber(5);
            }}
            onRewardClick={(certificate) => {
              setSelectedCertificate(certificate);
              setScreenNumber(8);
            }}
          />
        );
      }
      case 5: {
        return (
          <CertificateComponent
            selectedCertificate={selectedCertificate}
            setScreenNumber={setScreenNumber}
            onQuestionClick={() => setIsQuestionOpen(true)}
            onBought={(reward) => {
              setSelectedCertificate(reward);
              setScreenNumber(8);
            }}
          />
        );
      }
      case 6: {
        return (
          <QrCodeComponent
            setScreenNumber={setScreenNumber}
            onQuestionClick={() => setIsQuestionOpen(true)}
          />
        );
      }
      case 7: {
        return (
          <PhoneComponent
            setScreenNumber={setScreenNumber}
            onQuestionClick={() => setIsQuestionOpen(true)}
          />
        );
      }
      case 8: {
        return (
          <BarcodeComponent
            selectedCertificate={selectedCertificate}
            setScreenNumber={setScreenNumber}
            onBack={() => {
              setPointChangeTab('certificates');
              setScreenNumber(4);
            }}
            onQuestionClick={() => setIsQuestionOpen(true)}
          />
        );
      }
      case 9: {
        return (
          <ChangeErrorComponent
            setScreenNumber={setScreenNumber}
            onQuestionClick={() => setIsQuestionOpen(true)}
            onMainPageButtonClick={() => setScreenNumber(1)}
          />
        );
      }
      case 10: {
        return (
          <FaqComponent
            setScreenNumber={setScreenNumber}
            onQuestionClick={() => setIsQuestionOpen(true)}
          />
        );
      }
      case 11: {
        return <CookieManagementComponent setScreenNumber={setScreenNumber} />;
      }
      default: {
        return <ErrorComponent setScreenNumber={cb} />;
      }
    }
  };

  if (isAuthLoading) {
    return <div style={{ minHeight: '100vh', backgroundColor: '#440591' }} />;
  }

  return (
    <ScreensContext.Provider
      value={{
        endSessionType,
        setEndSessionType,
        isDisplayedAll,
        setIsDisplayedAll
      }}
    >
      {getScreen(screenNumber, setScreenNumber)}
      {isQuestionOpen && (
        <QuestionComponent onClose={() => setIsQuestionOpen(false)} />
      )}
      {!isTermsAccepted && screenNumber === 1 && (
        <TermsPopupComponent
          onAgree={handleAcceptTerms}
          onDisagree={() => {}}
          onRulesClick={() => setScreenNumber(2)}
        />
      )}
    </ScreensContext.Provider>
  );
};

export default SGMPersonalCabinet;
